export default __webpack_public_path__ + "static/outer_bottom-bd0c5a980c12f0e294c31065ab261414.png";